<template>
  <validation-observer ref="form">
    <v-card width="428">
      <v-card-title class="primary--text pa-4">
        Link existing {{ filterBy === 'media' ? 'media' : 'object' }}
      </v-card-title>
      <common-schema-selector
        class="px-4"
        v-model="schemaId"
        :list="schemaSelector()"
      />

      <validation-provider v-slot="{ errors }" name="object" rules="required">
        <v-autocomplete
          data-test="object"
          :error-messages="errors"
          :loading="isLoading"
          v-model="objectId"
          label="Object"
          clearable
          :items="objects"
          :menu-props="{ maxHeight: 200 }"
          item-value="id"
          item-text="name"
          class="px-4"
        >
          <template v-slot:item="item">
            <div :data-test-object="item.item.name">
              {{ item.item.name }}
            </div>
          </template>
        </v-autocomplete>
      </validation-provider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn
          text
          color="primary"
          @click="saveHandler"
          data-test="linkObject"
          :loading="loading"
          >Link
        </v-btn>
      </v-card-actions>
    </v-card>
  </validation-observer>
</template>

<script>
import { defineComponent, ref, watch } from '@vue/composition-api';
import { useMutation, useLazyQuery, useResult } from '@vue/apollo-composable';

import gql from '@/api/objects/item.graphql';
import gqlObjects from '@/api/objects/schemas.graphql';
import gqlUser from '@/api/users/item.graphql';
import CommonSchemaSelector from '@/components/app-entity/app-entity-tab/schedule/CommonSchemaSelector.vue';

import { required } from 'vee-validate';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { SCHEMA_SELECTOR } from '@/router/routes/schedules/constants';

extend('required', {
  ...required,
  message: 'This field is required'
});

export default defineComponent({
  components: {
    CommonSchemaSelector,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    targetToLink: {
      type: String
    },
    typeConnection: {
      type: String,
      default: 'objectToObjects'
    },
    filterBy: {
      type: String,
      default: 'object'
    }
  },
  setup(props, { emit, root }) {
    const schemaId = ref('');
    const objectId = ref('');
    const form = ref(null);

    const loadDevices = useLazyQuery(
      gqlObjects.loadRaw,
      {
        filter: {
          schemaId: {
            equalTo: schemaId.value
          }
        }
      },
      {
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'network-only'
      }
    );

    // watch(
    //   () => search.value,
    //   useDebounceFn(value => {
    //     if (!value) {
    //       loadDevices.variables.value.filter.name.includesInsensitive = '';
    //     } else {
    //       loadDevices.variables.value.filter.name.includesInsensitive = value;
    //     }
    //   }, 350)
    // );

    const { mutate: linkObjToObj } = useMutation(gql.connectObjectsToObject);
    const { mutate: linkObjToUser } = useMutation(gqlUser.createUsersToObject);

    const objects = useResult(loadDevices.result, [], data => {
      return data.objects;
    });

    const close = () => {
      emit('close');
    };

    const schemaSelector = () => {
      if (props.filterBy === 'media') {
        return SCHEMA_SELECTOR.filter(item => item.value === 'media');
      } else {
        return SCHEMA_SELECTOR.filter(item => item.value !== 'media');
      }
    };

    const saveHandler = () => {
      form.value.validate().then(success => {
        if (!success) {
          return;
        }

        if (props.typeConnection === 'objectToObjects') {
          linkObjToObj({
            input: {
              objectsToObject: {
                object1Id: props.targetToLink,
                object2Id: objectId.value
              }
            }
          }).then(() => {
            close();
          });
        } else {
          linkObjToUser({
            input: {
              usersToObject: {
                userId: root.$route.params.id,
                objectId: objectId.value
              }
            }
          }).then(() => {
            close();
          });
        }
      });
    };

    watch(
      () => schemaId.value,
      () => {
        if (schemaId.value) {
          loadDevices.variables.value.filter.schemaId.equalTo = schemaId.value;
          loadDevices.load();
        } else {
          objectId.value = null;
        }
      },
      {
        immediate: true
      }
    );

    return {
      saveHandler,
      close,
      objectId,
      isLoading: loadDevices.loading,
      objects,
      schemaId,
      form,
      schemaSelector
    };
  }
});
</script>
